import billToPages from './billTo';
import payerPages from './payer';
import shipToPages from './shipTo';
import soldToPages from './soldTo';

// *********** TEMPLATE MAP ************
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const templateMap: Record<string, { pages: any[] }> = {
  bill_to: {
    pages: billToPages
  },
  payer: {
    pages: payerPages
  },
  ship_to: {
    pages: shipToPages
  },
  sold_to: {
    pages: soldToPages
  }
};